import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
import MissionVision from './home/MissionVision'
import HomeWorkingProcess from './home/HomeWorkingProcess'
import OurDepartments from './home/OurDepartments'
import HomeFaq from './home/HomeFaq'
import HomeTestimonials from './home/HomeTestimonials'
import OurFacilites from './home/OurFacilites'
import OutTeam from './home/OutTeam'
import HomeBlog from './home/HomeBlog'
import DoctorsTimeTable from './home/DoctorsTimeTable'
import PressRelease from './home/PressRelease'
import HomeVideoGallery from './home/HomeVideoGallery'



const Home = () => {
  return (
    <>
      <HomeBanner />
      <PressRelease />
      <HomeAbout />
      <MissionVision />
      <OutTeam />
      {/* <DoctorsTimeTable /> */}
      <HomeWorkingProcess />
      <HomeVideoGallery />
      <OurDepartments />
      <OurFacilites />
      <HomeTestimonials />
      <HomeBlog />
      <HomeFaq />
      {/* <VideoGallery /> */}






    </>
  )
}

export default Home